<template
  ><div>
    <div class="vx-row">
      <div class="vx-col ml-auto mr-auto lg:w-1/2 w-full m-base">
        <h2>
          Tarieven in {{ recentPrice.date | toDate
          }}<vs-button
            color="primary"
            type="flat"
            icon-pack="feather"
            icon="icon-info"
            style="display: inline-block;"
            @click="infoActive = true"
          ></vs-button>
        </h2>
        <vs-popup title="Info" :active.sync="infoActive">
          <p>
            Voor de genoemde maand zijn dit de tarieven voor jouw contract. Als
            je een jaarcontract hebt, dan staan de tarieven voor electriciteit
            en gas voor één jaar vast. Bij een maandcontract veranderen deze per
            maand mee met de beweging van de marktprijzen. Bij een modelcontract
            veranderen deze per half jaar. Netbeheerkosten kunnen veranderen per
            maand (meestal 1 x keer per jaar) en worden vastgesteld door jouw
            netwerkbeheerder. De belastingen worden aan het begin van het jaar
            vastgesteld door de regering. Het vastrecht wordt hooguit 1 keer per
            jaar aangepast.
          </p>
        </vs-popup>
        <p style="text-align: right;">
          Alle genoemde tarieven zijn inclusief BTW. <br />Historische tarieven
          voor jouw contract zijn te vinden onderaan de pagina.<br />
        </p>

        <price-table :month-table="recentPrice" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col ml-auto mr-auto lg:w-1/2 w-full m-base">
        <vx-card title="Historische tarieven">
          <vs-table
            :data="historicPrices"
            noDataText="Geen historische tarieven beschikbaar."
          >
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.date">
                  <h5>{{ tr.date | toDate }}</h5>
                </vs-td>
                <template slot="expand">
                  <div class="vx-row mb-base">
                    <div
                      v-for="product in tr.products"
                      :key="product.product_type"
                      class="vx-col ml-auto mr-auto w-full xl:w-2/3 mt-base"
                    >
                      <vx-card
                        :title="$t(`Producttypes.${product.product_type}`)"
                      >
                        <table class="mb-base w-full">
                          <tr>
                            <th></th>
                            <th>Per</th>
                            <th style="text-align: right;">Prijs</th>
                          </tr>
                          <tr v-for="price in product.prices" :key="price.name">
                            <th>{{ price.name }}</th>
                            <td>
                              {{ $t(`PriceUnit.${price.unit}`) }}
                            </td>
                            <th style="text-align: right;">
                              <money-format
                                v-if="price.price_incl_vat"
                                :value="price.price_incl_vat"
                                locale="nl"
                                currency-code="EUR"
                                :subunit-value="true"
                                :hide-subunits="false"
                                :supplementalPrecision="3"
                              />
                            </th>
                          </tr>
                        </table>
                      </vx-card>
                    </div>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

import { mapState } from "vuex";
import PriceTable from "../components/PriceTable.vue";
import moment from "moment";

export default {
  props: ["id"],
  components: { PriceTable, MoneyFormat },
  computed: {
    ...mapState(["customerStatus", "contracts"]),
    recentPrice() {
      return this.prices != null ? this.prices[0] : {};
    },
    historicPrices() {
      return this.prices != null ? this.prices.slice(1) : [];
    }
  },
  data() {
    return {
      prices: null,
      infoActive: false
    };
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      await this.getPrices();
    },

    async getPrices() {
      if (this.id != null) {
        try {
          let res = await this.$http().get(`/api/Contracts/${this.id}/prices`);
          this.prices = res.data;
        } catch (e) {
          this.showError(
            "De tarieven konden op dit moment niet opgehaald worden, probeer het later nog eens",
            true,
            e
          );
        }
      }
    }
  },
  watch: {
    async contracts() {
      await this.initialize();
    }
  },
  filters: {
    toDate(value) {
      return moment(value)
        .locale("NL")
        .format("MMMM YYYY");
    }
  }
};
</script>

<style></style>
